import { render } from "./Notifications.vue?vue&type=template&id=51349c24"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "51349c24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51349c24', script)) {
    api.reload('51349c24', script)
  }
  
  module.hot.accept("./Notifications.vue?vue&type=template&id=51349c24", () => {
    api.rerender('51349c24', render)
  })

}

script.__file = "src/views/settings/modules/Notifications.vue"

export default script